import { render } from "./NewAssessementUploadForm.vue?vue&type=template&id=55f698a7"
import script from "./NewAssessementUploadForm.vue?vue&type=script&lang=js"
export * from "./NewAssessementUploadForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__